import type { UIMessage } from 'ai';

// backend は system メッセージを content で受け取る（parts は AIAssistantMessages の
// removeUnsupportedSystemParts で捨てられる）。UIMessage に content は無いため、
// 送信形に合わせて拡張した型で組み立てる。
type AISystemUIMessage = UIMessage & { content: string };

/**
 * AIアシスタントの会話先頭に置く system メッセージを組み立てる。
 * 空文字の要素は落とし、残りが無ければ null を返す。
 * 手動チャットと MCP 経路で同じ形のメッセージを送るために共有する。
 */
export function buildAISystemMessage(contents: string[]): AISystemUIMessage | null {
  const content = contents.filter((text) => text.length > 0).join('\n\n');
  if (content.length === 0) return null;

  return {
    role: 'system',
    id: `system-${Date.now()}`,
    parts: [],
    content,
  };
}
